import { Controller } from "@hotwired/stimulus";
import StimulusReflex from "stimulus_reflex";

export default class extends Controller {
  static targets = ["input", "results", "selectedId"];

  connect() {
    StimulusReflex.register(this);
    console.log("SubdivisionLocationSearchController connected");
    // alert("SubdivisionLocationSearchController connected");
  }

  search() {
    const query = this.inputTarget.value.trim();
    if (query.length < 2) {
      this.resultsTarget.classList.add("hidden");
      return;
    }

    // Get the country ID from the form or a data attribute
    const countryId = this.element.dataset.countryId || this.getCountryId();
    if (!countryId) {
      console.log("No country ID available for subdivision search");
      this.resultsTarget.classList.add("hidden");
      return;
    }

    // Set the query and country_id in the dataset for the reflex to access
    this.element.dataset.query = query;
    this.element.dataset.country_id = countryId;

    // Give the results div a unique ID based on this controller instance
    const uniqueId = `subdivision-results-${Date.now()}`;
    this.resultsTarget.id = uniqueId;
    this.element.dataset.resultsId = uniqueId;

    // Trigger the reflex
    this.stimulate("SubdivisionLocationSearch#search");
  }

  getCountryId() {
    // Try to find the country ID from the organization country search field
    const countryField = document.querySelector(
      '[data-organization-country-search-target="selectedId"]',
    );
    return countryField ? countryField.value : null;
  }

  // Reflex lifecycle methods
  beforeSearch() {
    this.resultsTarget.classList.add("opacity-50");
  }

  searchSuccess() {
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.remove("hidden");
  }

  searchError(error) {
    console.error("Subdivision location search error:", error);
    this.resultsTarget.classList.remove("opacity-50");
    this.resultsTarget.classList.add("hidden");
  }

  select(event) {
    const subdivisionId = event.currentTarget.dataset.subdivisionId;
    const subdivisionName = event.currentTarget.dataset.subdivisionName;

    this.selectedIdTarget.value = subdivisionId;
    this.inputTarget.value = subdivisionName;
    this.resultsTarget.classList.add("hidden");

    // Trigger change event for form validation
    this.inputTarget.dispatchEvent(new Event("change"));
  }
}
